<template>
  <div
    id="interactiveVideoContainer"
    class="syncc-stories-feed__interactive-video-container-ml238skcl"
    :style="videoOrientationStyle"
    ref="videoContainer"
  >
    <media-controller
      :key="playbackId"
      autohide="-1"
      class="syncc-stories-feed__media-controller-Q18nSj38d"
    >
      <div class="syncc-stories-feed__gradient-top-9Ndo12djx"></div>
      <mux-video
        :id="videoElId"
        slot="media"
        preload="auto"
        :class="{
          'mux-video__vertical-cover-fit': this.videoObjectFitStyle == 'COVER',
          'mux-video__vertical-contain-fit':
            this.videoObjectFitStyle == 'CONTAIN',
        }"
        :playback-id="muxSrc"
        :poster="videoThumbnailSrc"
        metadata-video-title="Sync stories-feed video in dev"
        metadata-viewer-user-id="user-id-1234"
        stream-type="on-demand"
        prefer-mse
        autoplay
        playsinline
        muted
        @canplay="switchToVideoView"
        @timeupdate="emitTimeUpdate"
        @ended="switchToNextVideo"
      ></mux-video>
      <media-control-bar
        class="syncc-stories-feed__media-controller-bar-cm98dowldss"
      >
        <div class="disable-background">
          <media-time-range
            class="syncc-stories-feed__media-time-range-bar-lxp12Mdss"
            :id="resolveMediaTimeRangeBar()"
            :media-current-time="currentTime"
            :media-duration="duration"
          ></media-time-range>
        </div>
      </media-control-bar>
    </media-controller>
  </div>
</template>


<script>
import "media-chrome";
import "@mux/mux-video";

import UserEngagement from "../../models/UserEngagement";
import Layout from "../../models/Layout";

export default {
  props: {
    partId: { type: String, required: true },
    videoObjectFitStyle: { type: String, required: true },
    currentSelectedVideo: { type: Boolean, required: true },
    playbackId: { type: String, required: true },
    jwt: { type: String, required: true },
    videoThumbnailSrc: { type: String, required: true },
  },
  data() {
    return {
      videoElId: "",
      isVideoPause: false,
      currentTime: "",
      duration: "",
      muxSrc: String,
      chaperShowMode: false,
      videoEl: null,
      mediaTimeRangeEl: null,
      tagKey: "",
      receivedSwitchToVideoView: false,
    };
  },
  created() {
    this.videoElId = "video-" + this.playbackId;
    this.muxSrc = this.playbackId + "?token=" + this.jwt;
  },
  mounted() {
    const videoElIdSelector = "#" + this.videoElId;
    const mediaTimeRangeBarElIdSelector = "#" + this.resolveMediaTimeRangeBar();
    if (this.tagKey) {
      const storiesFeedEls = document.querySelectorAll("syncc-stories-feed");
      storiesFeedEls.forEach((el) => {
        if (el.key == this.tagKey) {
          this.videoEl = el.shadowRoot.querySelector(videoElIdSelector);
          this.videoEl.muted = true;
          this.mediaTimeRangeEl = el.shadowRoot.querySelector(
            mediaTimeRangeBarElIdSelector
          );
          return;
        }
      });
    } else {
      this.videoEl = document
        .querySelectorAll("syncc-stories-feed")[0]
        .shadowRoot.querySelector(videoElIdSelector);
      // Notice: Prevent disabling autoplay with sound in ios env
      // After video loaded audio can be played
      this.videoEl.muted = true;
      this.mediaTimeRangeEl = document
        .querySelectorAll("syncc-stories-feed")[0]
        .shadowRoot.querySelector(mediaTimeRangeBarElIdSelector);
    }
  },
  beforeDestroy() {
    // TODO: パフォーマンスに問題ある場合、以下を利用してください
    // this.disposeVideo();
  },
  watch: {
    currentSelectedVideo: function (newVal, oldVal) {
      if (newVal == oldVal) {
        return;
      } else if (newVal) {
        this.currentTime = 0;
        this.videoEl.currentTime = 0;
        this.resume();
      } else {
        this.currentTime = 0;
        this.videoEl.currentTime = 0;
        this.pause();
      }
    },
  },
  methods: {
    resolveMediaTimeRangeBar() {
      return "mediaTimeRangeBar" + this.playbackId;
    },
    pause() {
      this.isVideoPause = true;
      this.mediaTimeRangeEl.setAttribute("media-paused", "");
      this.videoEl.pause();
    },
    resume() {
      this.isVideoPause = false;
      this.mediaTimeRangeEl.removeAttribute("media-paused");
      this.videoEl.play();
    },
    emitVideoDuration() {
      this.duration = this.videoEl.duration;
      this.$emit("on-get-video-duration", {
        partId: this.partId,
        videoDuration: this.duration,
      });
    },
    switchToVideoView() {
      if (!this.receivedSwitchToVideoView) {
        if (!this.currentSelectedVideo) {
          this.videoEl.currentTime = 0;
          this.videoEl.pause();
        }
        this.emitVideoDuration();
        this.$emit("can-play");
        // Notice: Prevent disabling autoplay with sound in ios env
        // After video loaded audio can be played
        this.videoEl.muted = false;
        this.receivedSwitchToVideoView = true;
      }
    },
    emitTimeUpdate() {
      if (!this.isVideoPause && this.videoEl.currentTime > this.currentTime) {
        this.currentTime = this.videoEl.currentTime;
        this.$emit("on-update-video-process-time", this.videoEl.currentTime);
      }
    },
    switchToNextVideo() {
      this.$emit("next-video-request");
    },
    disposeVideo() {
      // FiIXME: This function causes error: shadowRoot is not defined.
      /*
      var videoPlayerEl = shadowRoot.getElementById("video");
      videoPlayerEl.pause();
      videoPlayerEl.removeAttribute("playback-id"); // empty source
      videoPlayerEl.load();
      */
    },
  },
};
</script>
